import MessageBox from "sap/m/MessageBox";
import MessageToast from "sap/m/MessageToast";

/**
 * @namespace de.realcore.realseats.src.utils
 */
export default class UIFeedbackHelper {
    /**
     * Shows a confirmation dialog with customizable text.
     * @param message The message to display in the confirmation dialog.
     * @param title The title of the confirmation dialog.
     * @returns A promise that resolves to true if the user confirmed, false otherwise.
     */
    public static async showConfirmation(
        message: string,
        title: string = "Confirmation"
    ): Promise<boolean> {
        return new Promise((resolve) => {
            MessageBox.confirm(message, {
                title: title,
                onClose: (oAction: unknown) => resolve(oAction === MessageBox.Action.OK)
            });
        });
    }

    /**
     * Displays a success message with customizable text.
     * @param message The message to display in the toast notification.
     * @param duration The duration of the toast notification in milliseconds.
     */
    public static showSuccessMessage(message: string, duration: number = 3000) {
        MessageToast.show(message, { duration });
    }

    /**
     * Displays an error message in a dialog.
     * @param message The error message to display.
     * @param title The title of the error dialog.
     */
    public static showErrorMessage(message: string, title: string = "Error") {
        MessageBox.error(message, {
            title: title
        });
    }

    /**
     * Displays an information message in a dialog.
     * @param message The information message to display.
     * @param title The title of the information dialog.
     */
    public static showInfoMessage(message: string, title: string = "Information") {
        MessageBox.information(message, {
            title: title
        });
    }

    /**
     * Displays a warning message in a dialog.
     * @param message The warning message to display.
     * @param title The title of the warning dialog.
     */
    public static showWarningMessage(message: string, title: string = "Warning") {
        MessageBox.warning(message, {
            title: title
        });
    }
}
